import axios, { AxiosResponse } from "axios";
import contracts from "config/constants/contracts";
import useRefresh from "hooks/useRefresh";
import React, { useEffect, useState } from "react";
import { getAddress } from "utils/addressHelpers";

const {REACT_APP_KEY_NFT, REACT_APP_API_MORALIS_PIBRIDGE} = process.env;

export const FetDataPiBridge = (account) => {
    const [dataInfoNtf, setDataInfoNft] = useState({
        nameNft: '',
        token_id: null
    });
    const { fastRefresh } = useRefresh()
    useEffect(() => {
        
    const getData = async () => {
       
        
        try {
            const res: AxiosResponse<any, any> = await axios.get(`https://deep-index.moralis.io/api/v2/${account}/nft?chain=bsc&format=decimal&token_addresses=${getAddress(contracts.piNFTS)}`, {
                headers: {
                    "X-API-Key": REACT_APP_KEY_NFT
                }
            })
            setDataInfoNft({
                nameNft: res?.data?.result[0].name, 
                token_id: res?.data?.result[0].token_id 
            });
            
        } catch (error) {
            setDataInfoNft({
                nameNft: '',
                token_id: null
            })
        }
    }
    if (account) {
        getData();
    }
    }, [account, fastRefresh])
    return { dataInfoNtf }
}